module.exports = __webpack_public_path__ + "img/NewsTechnologyBanner.05cf0a5c.png";